import { Pipe, PipeTransform } from '@angular/core';
import { SDOHActionPlan } from '../models/sdoh-action-plan';

@Pipe({ name: 'filterSDOHActionPlans' })
export class FilterSDOHActionPlansPipe implements PipeTransform {
  transform(actionPlans: SDOHActionPlan[], isOpenTabSelected: boolean): SDOHActionPlan[] {
    if (actionPlans && actionPlans.length) {
      actionPlans = actionPlans.filter((actionPlan) =>
        isOpenTabSelected ? actionPlan.status === 'Open' : actionPlan.status === 'Closed'
      );

      if (!isOpenTabSelected) {
        actionPlans.sort((a, b) => {
          // Sort by modifiedDate, then by identifiedDate
          return a.modifiedDate === b.modifiedDate
            ? a.identifiedDate > b.identifiedDate
              ? -1
              : 1
            : a.modifiedDate > b.modifiedDate
              ? -1
              : 1;
        });
      }

      return actionPlans;
    }

    return [];
  }
}
